import store from '@/store'

const comprobarAuth = function(to) {
  // 1. Si el usuario es VIP (está en localStorage), tiene acceso pleno siempre
  if (localStorage.getItem('access') === 'vip') {
    return true
  }

  // 2. Si la ruta requiere autenticación
  if (to.matched.some(route => route.meta.requiresAuth)) {
    // Verificamos si tiene la cookie de sesión necesaria
    const hasOperationId = store.getters['login/cookie']('operationId') != null

    if (hasOperationId) {
      return true
    } else {
      // Guardamos a dónde quería ir el usuario para el post-login
      const redirectAfterLogin = {
        name: to.name,
        params: to.params,
        query: to.query
      }
      localStorage.setItem('redirectAfterLogin', JSON.stringify(redirectAfterLogin))
      return false
    }
  }

  // 3. Ruta de cancelación (caso específico que mencionaste)
  if (to.name === 'cancelacion' && store.getters['login/cookie']('operationId') != null) {
    localStorage.setItem('redirectAfterLogin', JSON.stringify({ name: to.name }))
    return false
  }

  // Por defecto, permitir acceso (rutas públicas)
  return true
}

const beforeEach = async function(to, from, next) {
  // LÓGICA DE PERSISTENCIA VIP
  // Si viene el parámetro en la URL, lo marcamos en localstorage para siempre
  if (to.query.access === 'vip') {
    localStorage.setItem('access', 'vip')
  }
  // Nota: Eliminé el borrado del VIP al entrar a 'home' para que el acceso sea "pleno" como pediste.

  // EXCEPCIÓN RUTA PHP
  if (to.path === '/cartapago.php') {
    return next()
  }

  // VALIDACIÓN DE ACCESO
  if (comprobarAuth(to)) {
    next()
  } else {
    // Si no tiene acceso, redirigir a tu ruta de login interna
    next({ name: 'login' })
  }
}

export default beforeEach
